export enum InstallationType {
	POLE = 'POLE',
	WALL = 'WALL',
}
